export default "__VITE_ASSET__BDm$pdcI__"